import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { CSSTransition } from 'react-transition-group';

import styles from './LightBox.module.scss';

const cx = classNames.bind(styles);

const LightBox = ({ handleClose, src, t }) => (
  <CSSTransition
    classNames={{
      enter: cx('container-enter'),
      enterActive: cx('container-enter-active'),
      exit: cx('container-exit'),
      exitActive: cx('container-exit-active'),
    }}
    in={!!src}
    mountOnEnter
    timeout={250}
    unmountOnExit
  >
    {/* eslint-disable-next-line */}
    <div
      aria-label={t('App/LightBox/aria-close')}
      className={cx('container')}
      onClick={handleClose}
      role="button"
    >
      <img alt="No description" className={cx('image')} src={src} />
    </div>
  </CSSTransition>
);

LightBox.propTypes = {
  handleClose: PropTypes.func.isRequired,
  src: PropTypes.string,
  t: PropTypes.func.isRequired,
};

LightBox.defaultProps = {
  src: undefined,
};

export default LightBox;
